export default function getCustomerPortalLinkForOffer(offer, isLedExperience) {
  return isLedExperience
    ? `/experience/${offer.result.slug}/led:${offer.result.id_salesforce_external}`
    : `/offer/${offer.result.slug}/${offer.result.id_salesforce_external}`;
}
